import { render } from "./MemorySectionSkeleton.vue?vue&type=template&id=6763ee91"
const script = {}

import "./MemorySectionSkeleton.vue?vue&type=style&index=0&id=6763ee91&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__